// import axios from 'axios';
import QS from 'qs';
import Vue from 'vue';
import { host, host1 } from '@/utils/host'
import $http from '../utils/http';

// 区县
export function area(params) {
    const url = host() + 'api/area';
    return new Promise((resolve, reject) => {
        $http.get(url, {
            params: params
        }).then(response => {
            if (response.state != 200) {
                return resolve(response);
            }
            resolve(response);
        }, err => {
            reject(err)
        }).catch(err => {
            reject(err)
        })
    });
};

// 行业
export function industry(params) {
    const url = host() + 'api/industry';
    return new Promise((resolve, reject) => {
        $http.get(url, {
            params: params
        }).then(response => {
            if (response.state != 200) {
                return resolve(response);
            }
            resolve(response);
        }, err => {
            reject(err)
        }).catch(err => {
            reject(err)
        })
    });
};


// 注册
export function register(params) {
    const url = host() + 'api/register';
    return new Promise((resolve, reject) => {
        $http.post(url, QS.stringify(params)).then(response => {
            return resolve(response);
        }, err => {
            reject(err)
        }).catch(err => {
            reject(err)
        })
    });
};


// 登录
export function login(params) {
    const url = host() + 'api/login';
    return new Promise((resolve, reject) => {
        $http.post(url, QS.stringify(params)).then(response => {
            return resolve(response);
        }, err => {
            reject(err)
        }).catch(err => {
            reject(err)
        })
    });
};

// 退出登录
export function logout(params) {
    const url = host() + 'api/logout';
    return new Promise((resolve, reject) => {
        $http.post(url, QS.stringify(params)).then(response => {
            return resolve(response);
        }, err => {
            reject(err)
        }).catch(err => {
            reject(err)
        })
    });
};

// 首页资讯公告
export function homeNews(params) {
    const url = host() + 'api/home/news';
    return new Promise((resolve, reject) => {
        $http.get(url, {
            params: params
        }).then(response => {
            if (response.state != 200) {
                return resolve(response);
            }
            resolve(response);
        }, err => {
            reject(err)
        }).catch(err => {
            reject(err)
        })
    });
};

// 首页示范企业
export function homeCompany(params) {
    const url = host() + 'api/home/company';
    return new Promise((resolve, reject) => {
        $http.get(url, {
            params: params
        }).then(response => {
            if (response.state != 200) {
                return resolve(response);
            }
            resolve(response);
        }, err => {
            reject(err)
        }).catch(err => {
            reject(err)
        })
    });
};

// 资讯公告
export function news(params) {
    const url = host() + 'api/news';
    return new Promise((resolve, reject) => {
        $http.get(url, {
            params: params
        }).then(response => {
            if (response.state != 200) {
                return resolve(response);
            }
            resolve(response);
        }, err => {
            reject(err)
        }).catch(err => {
            reject(err)
        })
    });
};

// 资讯公告详细
export function newsInfo(params) {
    const url = host() + 'api/news_info';
    return new Promise((resolve, reject) => {
        $http.get(url, {
            params: params
        }).then(response => {
            if (response.state != 200) {
                return resolve(response);
            }
            resolve(response);
        }, err => {
            reject(err)
        }).catch(err => {
            reject(err)
        })
    });
};

// 消息列表
export function message(params) {
    const url = host() + 'api/message';
    return new Promise((resolve, reject) => {
        $http.get(url, {
            params: params
        }).then(response => {
            if (response.state != 200) {
                return resolve(response);
            }
            resolve(response);
        }, err => {
            reject(err)
        }).catch(err => {
            reject(err)
        })
    });
};

// 设置消息为已读
export function messageRead(params) {
    const url = host() + 'api/message/read';
    return new Promise((resolve, reject) => {
        $http.post(url, QS.stringify(params)).then(response => {
            return resolve(response);
        }, err => {
            reject(err)
        }).catch(err => {
            reject(err)
        })
    });
};

// 未读消息列表数量
export function messageNewNum(params) {
    const url = host() + 'api/message/new_num';
    return new Promise((resolve, reject) => {
        $http.get(url, {
            params: params
        }).then(response => {
            if (response.state != 200) {
                return resolve(response);
            }
            resolve(response);
        }, err => {
            reject(err)
        }).catch(err => {
            reject(err)
        })
    });
};

// 验收申请_保存提交
export function applyForSubmit(params) {
    const url = host() + 'api/apply_for_submit';
    return new Promise((resolve, reject) => {
        $http.post(url, QS.stringify(params)).then(response => {
            return resolve(response);
        }, err => {
            reject(err)
        }).catch(err => {
            reject(err)
        })
    });
};

// 验收申请详细
export function applyForInfo(params) {
    const url = host() + 'api/apply_for_info';
    return new Promise((resolve, reject) => {
        $http.get(url, {
            params: params
        }).then(response => {
            if (response.state != 200) {
                return resolve(response);
            }
            resolve(response);
        }, err => {
            reject(err)
        }).catch(err => {
            reject(err)
        })
    });
};

// 是否提示
export function digitalIsTip(params) {
    const url = host() + 'api/digital/isTip';
    return new Promise((resolve, reject) => {
        $http.get(url, {
            params: params
        }).then(response => {
            if (response.state != 200) {
                return resolve(response);
            }
            resolve(response);
        }, err => {
            reject(err)
        }).catch(err => {
            reject(err)
        })
    });
};

// 不再显示
export function digitalNoTip(params) {
    const url = host() + 'api/digital/noTip';
    return new Promise((resolve, reject) => {
        $http.post(url, QS.stringify(params)).then(response => {
            return resolve(response);
        }, err => {
            reject(err)
        }).catch(err => {
            reject(err)
        })
    });
};

// 答题提交
export function digitalSubmit(params) {
    const url = host() + 'api/digital/submit';
    return new Promise((resolve, reject) => {
        $http.post(url, QS.stringify(params)).then(response => {
            return resolve(response);
        }, err => {
            reject(err)
        }).catch(err => {
            reject(err)
        })
    });
};

// 测评报告详细
export function digitalReport(params) {
    const url = host() + 'api/digital/report';
    return new Promise((resolve, reject) => {
        $http.get(url, {
            params: params
        }).then(response => {
            if (response.state != 200) {
                return resolve(response);
            }
            resolve(response);
        }, err => {
            reject(err)
        }).catch(err => {
            reject(err)
        })
    });
};

// 测评记录
export function reportList(params) {
    const url = host() + 'api/digital/reportList';
    return new Promise((resolve, reject) => {
        $http.get(url, {
            params: params
        }).then(response => {
            if (response.state != 200) {
                return resolve(response);
            }
            resolve(response);
        }, err => {
            reject(err)
        }).catch(err => {
            reject(err)
        })
    });
};

// 删除测评记录
export function reportDel(params) {
    const url = host() + 'api/digital/reportDel';
    return new Promise((resolve, reject) => {
        $http.post(url, QS.stringify(params)).then(response => {
            return resolve(response);
        }, err => {
            reject(err)
        }).catch(err => {
            reject(err)
        })
    });
};

// 数字化产品列表
export function digitalProduct(params) {
    const url = host() + 'api/digital/product';
    return new Promise((resolve, reject) => {
        $http.get(url, {
            params: params
        }).then(response => {
            if (response.state != 200) {
                return resolve(response);
            }
            resolve(response);
        }, err => {
            reject(err)
        }).catch(err => {
            reject(err)
        })
    });
};

// 产品类别
export function digitalProductCategory(params) {
    const url = host() + 'api/digital/product_category';
    return new Promise((resolve, reject) => {
        $http.get(url, {
            params: params
        }).then(response => {
            if (response.state != 200) {
                return resolve(response);
            }
            resolve(response);
        }, err => {
            reject(err)
        }).catch(err => {
            reject(err)
        })
    });
};

// 加入购物车
export function addShoppingCart(params) {
    const url = host() + 'api/digital/addShoppingCart';
    return new Promise((resolve, reject) => {
        $http.post(url, QS.stringify(params)).then(response => {
            return resolve(response);
        }, err => {
            reject(err)
        }).catch(err => {
            reject(err)
        })
    });
};

// 删除购物车
export function delShoppingCart(params) {
    const url = host() + 'api/digital/delShoppingCart';
    return new Promise((resolve, reject) => {
        $http.post(url, QS.stringify(params)).then(response => {
            return resolve(response);
        }, err => {
            reject(err)
        }).catch(err => {
            reject(err)
        })
    });
};

// 购物车列表
export function shoppingCartList(params) {
    const url = host() + 'api/digital/shoppingCartList';
    return new Promise((resolve, reject) => {
        $http.get(url, {
            params: params
        }).then(response => {
            if (response.state != 200) {
                return resolve(response);
            }
            resolve(response);
        }, err => {
            reject(err)
        }).catch(err => {
            reject(err)
        })
    });
};

// 政策列表
export function policyCategoryList(params) {
    const url = host() + 'api/policy_category/list';
    return new Promise((resolve, reject) => {
        $http.get(url, {
            params: params
        }).then(response => {
            if (response.state != 200) {
                return resolve(response);
            }
            resolve(response);
        }, err => {
            reject(err)
        }).catch(err => {
            reject(err)
        })
    });
};


// 参考模板列表
export function templatesList(params) {
    const url = host() + 'api/templates/list';
    return new Promise((resolve, reject) => {
        $http.get(url, {
            params: params
        }).then(response => {
            if (response.state != 200) {
                return resolve(response);
            }
            resolve(response);
        }, err => {
            reject(err)
        }).catch(err => {
            reject(err)
        })
    });
};

// 删除购物车
export function delQuestionUpload(params) {
    const url = host() + 'api/apply_for_question_del_upload';
    return new Promise((resolve, reject) => {
        $http.post(url, QS.stringify(params)).then(response => {
            return resolve(response);
        }, err => {
            reject(err)
        }).catch(err => {
            reject(err)
        })
    });
};

// 资讯公告详细
export function wx_newsInfo(params) {
    const url = host1() + '/news/detail';
    return new Promise((resolve, reject) => {
        $http.get(url, {
            params: params
        }).then(response => {
            if (response.state != 200) {
                return resolve(response);
            }
            resolve(response);
        }, err => {
            reject(err)
        }).catch(err => {
            reject(err)
        })
    });
};


// WEBPACK FOOTER //
// ./src/api/api.js